import { render, staticRenderFns } from "./sanitary_dashboard.vue?vue&type=template&id=4ad9bcc2&"
import script from "./sanitary_dashboard.vue?vue&type=script&lang=js&"
export * from "./sanitary_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports